export const frontendURI = '/cat/contact_info_type/';
export const backendURI = `/api${frontendURI}`;
